<textarea
	[name]="'input' + name"
	type="text"
	class="form-control"
	[ngModel]="model"
	[ngClass]="classes()"
	readonly
	inert
	[rows]="numberOfRows()"
></textarea>
